export const TargetParamsAbi = [
  {
    name: 'skipRevert',
    type: 'bool',
    internalType: 'bool',
  },
  {
    name: 'addr',
    type: 'address',
    internalType: 'address',
  },
  {
    name: 'value',
    type: 'uint256',
    internalType: 'uint256',
  },
  {
    name: 'data',
    type: 'bytes',
    internalType: 'bytes',
  },
] as const

export const TradeParamsAbi = [
  {
    internalType: 'bool',
    name: 'skipRevert',
    type: 'bool',
  },
  {
    internalType: 'Currency',
    name: 'currency',
    type: 'address',
  },
  {
    internalType: 'address',
    name: 'allowanceTarget',
    type: 'address',
  },
  {
    internalType: 'address',
    name: 'addr',
    type: 'address',
  },
  {
    internalType: 'uint256',
    name: 'value',
    type: 'uint256',
  },
  {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes',
  },
] as const

export const MessageCallbackAbi = [
  {
    type: 'tuple[]',
    name: 'trades',
    components: TradeParamsAbi,
  },
  {
    type: 'tuple',
    name: 'callback',
    components: TargetParamsAbi,
  },
] as const
